import {Component, EventEmitter, HostListener, Input, OnInit, Output, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ApiClientService} from '../../../services/api-client.service';
import {ConstantsService} from '../../../services/constants.service';
import {EmailService} from '../../../services/email.service';

declare const toastr: any;
declare const $: any;
declare const swal: any;
declare const moment: any;

@Component({
    selector: 'email-scheduling-modal',
    templateUrl: './email-scheduling-modal.component.html',
    styleUrls: ['./email-scheduling-modal.component.scss']
})
export class EmailSchedulingModalComponent implements OnInit {
    @ViewChild('form') form;
    @Input('message') message;
    @Output('send') send: EventEmitter<any> = new EventEmitter();
    showModal = false;
    date: Date;
    currentTime = new Date();
    time = '';
    disabledSubmit = false;
    showSpinner = false;

    constructor(
        public es: EmailService,
        public api: ApiClientService
    ) {}

    ngOnInit() {
        this.initData();
        this.initTimePicker();
        setTimeout( () => this.showModal = true, 300);
    }

    initData() {
        if(this.message.status == 'scheduled') {
            this.date = moment(this.message.scheduleDate.slice(0, -6) + moment().format('Z'))._d;
            // Changing the time from 0 timezone to the local, to propertly initialize time in timepicker
            this.time = moment(this.message.scheduleDate.slice(0, -6) + moment().format('Z')).format('h:mm A');
        } else {
            this.date = new Date();
            this.time = moment().format('h:mm A');
        }
    }

    initTimePicker() {
        $('#timepicker').timepicker().on('changeTime.timepicker', e => this.time = e.time.value);
    }

    openTimepicker(): void {
        $('#timepicker').timepicker('showWidget');
    }

    hideModal() {
        if (this.form.dirty && this.form.touched) {
            swal(ConstantsService.getSwalConfig('Close without saving?', 'Do you want to delete unsaved data?'),
                () => {
                    this.es.isEmailSchedulingModalShow = false;
                }
            );
        } else {
            this.es.isEmailSchedulingModalShow = false;
        }
    }

    onSubmit(form: NgForm) {
        if(this.timeIsLessThanCurrent()) {
            toastr.warning('Time must be later than current');
            return;
        }
        if(this.date && this.time && form.controls.date.value && form.controls.time.value) {
            this.message.status = 'scheduled';
            this.message.scheduleDate = this.getDateTimeFromForm();
            this.form.reset();
            this.send.emit();
            this.hideModal();
        } else
            toastr.warning('All fields must be filled to proceed.');
    }

    updateView(msg: string): void {
        toastr.success(msg);
        this.form.reset();
        this.hideModal();
    }

    getDateTimeFromForm(): Date {
        const date = new Date(this.date);
        const time = this.time;
        const timeObj = new Date(`01/01/1970 ${time}`);
        const hours   = timeObj.getHours();
        const minutes = timeObj.getMinutes();
        date.setHours(hours);
        date.setMinutes(minutes);
        return new Date(moment(date).format().slice(0, -6) + '-00:00');
    }

    timeIsLessThanCurrent() {
        const date = new Date(this.date);
        const time = this.time;
        const timeObj = new Date(`01/01/1970 ${time}`);
        const hours   = timeObj.getHours();
        const minutes = timeObj.getMinutes();
        date.setHours(hours);
        date.setMinutes(minutes);
        return moment(date) <= new Date();
    }

    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        setTimeout(() => this.hideModal(), 100);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/email/email-scheduling-modal/email-scheduling-modal.component.ts